import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import AppSelect from "../../common/AppSelect";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import numberFormat from "../../common/numberFormat";
import Body from "../../components/Body";

import api from "../../config/api";
import { toast } from "react-toastify";
import { getEmployees } from "../../stores/EmployeeStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const formInit = {
  date: new Date().toISOString(),
  employee: "",
  amount: "",
  comment: "",
};
export default function PaySalary({ history }) {
  const [form, setForm] = useState(cloneDeep(formInit));
  const [focus, setFocus] = useState();
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const { data: categories } = useQuery({
    queryFn: () => getEmployees(),
    queryKey: ["employees"],
  });

  const handleChange = ({ currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    setForm({ ...form, [name]: value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.employee) {
      return setFocus({ ...focus, employee: Math.random() });
    }

    setDisabled(true);
    const cat = categories?.find((i) => i.name === form.employee);
    const res = await api.post("salary", { ...form, employee: cat._id });
    if (!res.ok) {
      setDisabled(false);
      toast.error(res.originalError.message);
    }
    queryClient.invalidateQueries(["salary"], ["expenses"]);

    setForm(formInit);
    setDisabled(false);
    toast.success("Expense has been successfully added.");
    history.replace("/expenses/list");
  };

  return (
    <Body title="Pay Salary" back>
      <div>
        <div style={{ marginTop: 30 }}>
          <form onSubmit={handleSubmit}>
            <DetailBlock>
              <div className="d-flex" style={{ gap: "0px 40px" }}>
                <LabelInput
                  name="date"
                  placeholder="Date"
                  datePicker
                  value={form.date}
                  onChange={handleChange}
                  required
                  containerStyle={{ height: 80 }}
                />
                <AppSelect
                  name="employee"
                  value={form.employee}
                  onChange={handleChange}
                  required
                  placeholder="Employee"
                  focused={focus?.category}
                  containerStyle={{ height: 90 }}
                  options={categories?.map((i) => i.name)}
                />
                <LabelInput
                  name="amount"
                  value={numberFormat(form.amount)}
                  onChange={handleChange}
                  required
                  placeholder="Amount"
                  containerStyle={{ height: 90 }}
                />
                <LabelInput
                  name="comment"
                  value={form.comment}
                  onChange={handleChange}
                  required
                  placeholder="Comment"
                  containerStyle={{ height: 90 }}
                />
              </div>
            </DetailBlock>
            <AppButton
              disabled={disabled}
              text="Pay Salary"
              className="btn-primary"
              style={{ margin: "10px 0px" }}
            />
          </form>
        </div>
      </div>
    </Body>
  );
}
